module.exports = __webpack_public_path__ + "2d93cb6cbd1709689524c55bc2ee9132.pdf";